import { Avatar, Box, Flex, Typography } from "../../../ppui";

export const AttendanceHeaders = (currentPage, rowsPerPage) => [
  {
    key: "slNo",
    label: "SL No.",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "name",
    label: "Employee Name",
    isClickable: false,
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => <>

      <Flex alignItems="center" >
        <Avatar
          className={"avatarHover"}
          size="xs"
          color="secondary"
          initials={`${row?.employees?.first_name.trim().substring(0, 1).toUpperCase()}${row?.employees?.last_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
          sx={{ marginInlineEnd: "0.625rem" }}
        />
        <Box >
          {row?.employees?.first_name} {row?.employees?.last_name}
          <Typography
            color={"default"}
            colorVariant={"light"}
            variant={"body3"}
            mb={"0"}
          >
            #{row?.employees?.employee_code}
          </Typography>
        </Box>
      </Flex>
    </>,
  },
  {
    key: "monthDays",
    label: "Month Days",
    align: "left",
    isShortable: false,
    isVisible: false,
    getValue: (row) => row?.month_days || "0",
  },
  {
    key: "declaredHoliday",
    label: "Declared Holiday",
    align: "left",
    isShortable: false,
    isVisible: false,
    getValue: (row) => row?.declared_holiday || "0",
  },
  {
    key: "weeklyOff",
    label: "Weekly Off",
    align: "left",
    isShortable: false,
    isVisible: false,
    getValue: (row) => row?.total_weekly_off || "0",
  },
  {
    key: "scopeOfWorkDays",
    label: "Scope Of Work Days",
    align: "left",
    isShortable: true,
    isVisible: false,
    getValue: (row) => row?.scopeOfWorkDays || "0",
  },
  {
    key: "presentDays",
    label: "Present Days",
    align: "left",
    isShortable: true,
    isVisible: false,
    getValue: (row) => row?.present_days || "0",
  },
  {
    key: "leaveDays",
    label: "Leave",
    align: "left",
    isShortable: true,
    isVisible: false,
    getValue: (row) => row?.total_payable_leave || "0",
  },
  {
    key: "payableDays",
    label: "Payable Days",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row?.payable_days || "0",
  },
  {
    key: "ncpDays",
    label: "NCP Days",
    align: "left",
    isShortable: true,
    isVisible: false,
    getValue: (row) => row?.ncp_days || "0",
  },
  {
    key: "remarks",
    label: "Remarks",
    align: "left",
    isShortable: true,
    isVisible: false,
    getValue: (row) => {
      const joinDate = row?.employees?.join_date ? new Date(row.employees.join_date) : null;
      
      let exitDate = row?.employees?.exit_date ? new Date(row.employees.exit_date) : null;
      
      if (!exitDate && row?.employees?.exit_formalities?.length > 0) {
        exitDate = new Date(row.employees.exit_formalities[0].exit_date);
      }
  
      const recordMonth = row?.month;  
      const recordYear = row?.year;   
  
      if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
        return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
  
      if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
        return `Employee exited at ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      if (row?.ncp_days === row?.month_days) {
        return `This employee did not work for the entire month.`;
      }
      return row?.remarks || "--";
    },
  }
];
